import React from 'react';
import { Button, Alert } from 'reactstrap';
import '../EpikBoxObis/EpikBoxObis.css';
import BoxPhones from './BoxPhones';

const EpikboxPhones = props => {
  const { showPhonesModal, user, phones, onPhoneDelete, BoxPhoneClicked, enableBoxEdit } = props;
  return (
    <div className="obisContainer">
      {phones.length !== 0 ? (
        phones.map((item, idx) => {
          return (
            <BoxPhones
              user={user}
              phone={item}
              onPhoneDelete={onPhoneDelete}
              BoxPhoneClicked={BoxPhoneClicked}
              key={idx}
            />
          );
        })
      ) : (
        <Alert style={{ width: '100%' }} color="info">
          No phone record found
        </Alert>
      )}
      {user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'supportEngineer' ? (
        <div className="epiFooter">
          <Button
            color="primary"
            disabled={!enableBoxEdit}
            style={{ marginRight: '15px' }}
            onClick={ev => {
              showPhonesModal();
            }}
          >
            Assign phone
          </Button>
          <Button disabled={!enableBoxEdit} color="primary">
            Push Configuration
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default EpikboxPhones;
